"use client";
import Image from "next/image";
import React from "react";
import { Carousel, Card } from "@/components/ui/Card/CardsCarousel";

export function Project() {
  const cards = data.map((card, index) => (
    <Card key={card.src} card={card} index={index} />
  ));

  return (
    <div className="bg-white dark:bg-[#171420]">
      <div className="container w-full h-full my-20 py-20">
        <div className="text-left">
          <span className="text-xl text-main-green font-medium">Tiêu biểu</span>
          <h1 className="text-primary dark:text-[#45c3dc] uppercase text-4xl lg:text-5xl font-bold mt-4">
            Một số dự án mình làm
          </h1>
        </div>
        <Carousel items={cards} />
      </div>
    </div>
  );
}

const DummyContent = () => {
  return (
    <>
      {[...new Array(3).fill(1)].map((_, index) => {
        return (
          <div
            key={"dummy-content" + index}
            className="bg-[#F5F5F7] dark:bg-neutral-800 p-8 md:p-14 rounded-3xl mb-4"
          >
            <p className="text-neutral-600 dark:text-neutral-400 text-base md:text-2xl font-sans max-w-3xl mx-auto">
              <span className="font-bold text-neutral-700 dark:text-neutral-200">
                The first rule of Apple club is that you boast about Apple club.
              </span>{" "}
              Keep a journal, quickly jot down a grocery list, and take amazing
              class notes. Want to convert those notes to text? No problem.
              Langotiya jeetu ka mara hua yaar is ready to capture every
              thought.
            </p>
            <Image
              src="https://assets.aceternity.com/macbook.png"
              alt="Macbook mockup from Aceternity UI"
              height="500"
              width="500"
              className="md:w-1/2 md:h-1/2 h-full w-full mx-auto object-contain"
            />
          </div>
        );
      })}
    </>
  );
};

const data = [
  {
    category: "Y tế",
    title: "App khám bệnh và giao thuốc online",
    src: "/images/projects/khambenh.jpg",
    content: <DummyContent />,
  },
  {
    category: "Tài chính",
    title: "Ứng dụng đầu tư bất động sản",
    src: "/images/projects/bds.jpg",
    content: <DummyContent />,
  },
  {
    category: "Website",
    title: "GSL Holdings Group",
    src: "/images/projects/gsl.png",
    content: <DummyContent />,
  },

  {
    category: "Website",
    title: "Onefilm",
    src: "/images/projects/onefilm.png",
    content: <DummyContent />,
  },
  {
    category: "Website",
    title: "Oani Spa",
    src: "/images/projects/oani.png",
    content: <DummyContent />,
  },
  {
    category: "Website",
    title: "Novas (Pending)",
    src: "/images/projects/novas.png",
    content: <DummyContent />,
  },
  {
    category: "Games",
    title: "HTML5 Games",
    src: "/images/projects/html5.png",
    content: <DummyContent />,
  },
];
